import { render, staticRenderFns } from "./GoodsSpecSelects.vue?vue&type=template&id=3c5be042&scoped=true"
import script from "./GoodsSpecSelects.vue?vue&type=script&lang=js"
export * from "./GoodsSpecSelects.vue?vue&type=script&lang=js"
import style0 from "./GoodsSpecSelects.vue?vue&type=style&index=0&id=3c5be042&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c5be042",
  null
  
)

export default component.exports